<template>
  <ul class="sort clearfix">
    <li :class="{ active: sort == 0 }" @click="changeSort(0)">综合</li>
    <li :class="{ active: sort == 1 }" @click="changeSort(1)">最新</li>
    <li :class="{ active: sort == 2 }" @click="changeSort(2)">最热</li>
    <li
      v-if="!isOpen"
      class="sort-price"
      :class="{
        active: sort == 3 || sort == 4,
        desc: sort == '4',
        asc: sort == '3',
      }"
      @click="changeSort(sort == 3 ? 4 : 3)"
    >
      价格
    </li>
  </ul>
</template>
<script>
export default {
  name: 'ListSort',
  props: {
    value: {
      type: Number,
      default: 0,
    },
    isOpen: {
      type: Boolean,
      default: false,
    },
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  data() {
    return {
      sort: this.value,
    };
  },
  watch: {
    value(newValue) {
      this.sort = newValue;
    },
    sort(newValue) {
      this.$emit('change', newValue);
    },
  },
  methods: {
    changeSort(sort) {
      this.sort = sort;
    },
  },
};
</script>
<style lang="scss" scoped>
.sort {
  padding: 12px 0;
  display: flex;
  li {
    font-size: 14px;
    line-height: 22px;
    color: #666;
    cursor: pointer;
    margin-left: 24px;
    &.active {
      color: $primary-color;
    }
    &:first-child {
      margin-left: 0 !important;
    }
    &.sort-price {
      position: relative;
      &::after {
        content: '';
        width: 12px;
        height: 14px;
        position: absolute;
        background-size: 100% 100%;
        background-image: url('~@/assets/images/common/sort@2x.png');
        top: 50%;
        transform: translateY(-50%);
        right: -17px;
      }

      &.asc::after {
        background-image: url('~@/assets/images/common/sort-asc@2x.png');
      }

      &.desc::after {
        background-image: url('~@/assets/images/common/sort-desc@2x.png');
      }
    }
  }
}
</style>
